import React, {useMemo} from 'react';
import {Link} from 'react-router-dom';
import {useTable, usePagination, useFilters} from 'react-table';
import {Table, Popup} from 'semantic-ui-react';
import {Filter, DefaultColumnFilter} from '../common/TableFilters';
import TablePaginator from '../common/TablePaginator';
    
export const columnsExcelTable = (data) => {
  return ([
    {
      'Header': 'DEALER',
      'accessor': 'dealerId',
    },
    {
      'Header': 'CODIGO RECLAMO',
      'accessor': 'reclaimCode',
    },
    {
      'Header': 'CAMPAÑA',
      'accessor': 'campaignId',
    },
    {
      'Header': 'TIPO',
      'accessor': 'operationType',
    },
    {
      'Header': 'NUM TWC DEALER',
      'accessor': 'numTwcDealer',
    },
    {
      'Header': 'FACTURA',
      'accessor': 'numFac',
    },
    {
      'Header': 'ORDEN REPARACION',
      'accessor': 'orderRepairId',
    },
    {
      'Header': 'CHASIS',
      'accessor': 'chassis',
    },
    {
      'Header': 'FECHA VENTA',
      'accessor': 'salesDate',
    },
    {
      'Header': 'KM',
      'accessor': 'km',
    },
    {
      'Header': 'FECHA REPARACION',
      'accessor': 'repairDate',
    },
    {
      'Header': 'FECHA ACTUAL',
      'accessor': 'actualDate',
    },
    {
      'Header': 'OFP PARTE',
      'accessor': 'principalPart',
    },
    {
      'Header': 'FECHA PROCESO INICIAL',
      'accessor': 'processDate',
    },
    {
      'Header': 'FECHA APERTURA REPARACION',
      'accessor': 'openRepairDate',
    },
    {
      'Header': 'FECHA FINAL REPARACION',
      'accessor': 'endRepairDate',
    },
    {
      'Header': 'CONDICION',
      'accessor': 'condition',
    },
    {
      'Header': 'CAUSA',
      'accessor': 'cause',
    },
    {
      'Header': 'REPARACION',
      'accessor': 'repair',
    },
    {
      'Header': 'TAREA',
      'accessor': 'taskId',
    },
    {
      'Header': 'HORAS',
      'accessor': 'hours',
    },
    {
      'Header': 'PARTE 1',
      'accessor': 'partNo1',
    },
    {
      'Header': 'CANTIDAD 1',
      'accessor': 'quantity1',
    },
    {
      'Header': 'PARTE 2',
      'accessor': 'partNo2',
    },
    {
      'Header': 'CANTIDAD 2',
      'accessor': 'quantity2',
    },
    {
      'Header': 'PARTE 3',
      'accessor': 'partNo3',
    },
    {
      'Header': 'CANTIDAD 3',
      'accessor': 'quantity3',
    },
    {
      'Header': 'PARTE 4',
      'accessor': 'partNo4',
    },
    {
      'Header': 'CANTIDAD 4',
      'accessor': 'quantity4',
    },
    {
      'id': 'actions',
      'Header': 'ACCIONES',
      'Cell': ({row}) => {
        const {code, numTwcDealer, dealerId} = row.original;

        if (code && numTwcDealer && dealerId) {
          return (
            <>
              <Popup
                trigger={
                  <Link
                    to={`/editar-garantias-admin/${code}/${numTwcDealer}/${dealerId}`}
                    target='_blank'
                  >
                    <span className='link edition'>
                      <i className='material-icons'>edit</i>
                    </span>
                  </Link>
                }
                content={`Editar Garantía ${code}`}
                position='top center'
                inverted
              />
            </>
          );
        }
        return null;
      },
    },
  ]);
};

const getCellErrorStyle = (error) => {
  if (error) {
    return {
      'style': {
        'color': '#9f3a38',
        'background': '#fff6f6',
      },
    };
  }

  return {};
};

const CustomCell = ({cell}) => {
  const valueKey = cell.column.id;
  const valueError = cell.row.original[`${valueKey}Error`];

  if (valueError) {
    return (
      <Popup
        trigger={
          <Table.Cell
            textAlign='center'
            className='cell-error'
            {...cell.getCellProps(getCellErrorStyle(valueError))}
          >
            {cell.render('Cell')}
          </Table.Cell>
        }
        content={valueError}
        position='top center'
        size='small'
        inverted
      />
    );
  }

  return (
    <Table.Cell
      textAlign="center"
      {...cell.getCellProps(getCellErrorStyle(valueError))}
    >
      {cell.render('Cell')}
    </Table.Cell>
  );
};

const WarrantyInsertTable = ({dataTable}) => {
  const columsExcel = columnsExcelTable(dataTable);
  const data = useMemo(() => dataTable, [dataTable]);
  const columns = useMemo(() => columsExcel, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    'state': {pageIndex, pageSize},
  } = useTable(
    {
      columns,
      data,
      'defaultColumn': {'Filter': DefaultColumnFilter},
      'initialState': {'pageIndex': 0, 'pageSize': 10},
    },
    useFilters,
    usePagination
  );
  return (
    <>
      <div className='table-container'>
        <Table className='interactive' striped {...getTableProps()}>
          <Table.Header>
            {headerGroups.map((headerGroup) => (
              <Table.Row key='headers' {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell
                    key={`title-${index}`}
                    textAlign='center'
                    {...column.getHeaderProps()}
                  >
                    {column.render('Header')}
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
            {headerGroups.map((headerGroup) => {
              if (data.length) {
                return (
                  <Table.Row key='filters' id='filters'>
                    {headerGroup.headers.map((column, index) => (
                      <Table.HeaderCell
                        key={`filter-${index}`}
                        textAlign='center'
                      >
                        <Filter column={column} />
                      </Table.HeaderCell>
                    ))}
                  </Table.Row>
                );
              }
              return null;
            })}
          </Table.Header>
          <Table.Body {...getTableBodyProps()}>
            {!page.length && (
              <Table.Row>
                <Table.Cell colSpan={26} textAlign='center'>
                  No hay datos disponibles
                </Table.Cell>
              </Table.Row>
            )}
            {page.length > 0 &&
              page.map((row, i) => {
                prepareRow(row);
                return (
                  <Table.Row key={i}>
                    {row.cells.map((cell, idx) => (
                      <CustomCell
                        key={idx}
                        cell={cell}
                      />
                    ))}
                  </Table.Row>
                );
              })}
          </Table.Body>
        </Table>
      </div>
      <TablePaginator
        data={data}
        canPreviousPage={canPreviousPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        pageSize={pageSize}
        canNextPage={canNextPage}
        nextPage={nextPage}
        gotoPage={gotoPage}
        previousPage={previousPage}
        setPageSize={setPageSize}
      />
    </>
  );
};

export default WarrantyInsertTable;
